// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Orkj","index":"styles_index__JAVdP"};